/** @format */

import {AccountDesignsOrdersContext} from '../../../context/AccountDesignsOrdersContext';
import {validateOrderWithErrors} from '../../../../../ds/quoter/functions/validate';
import DimensionValidator from 'frontier/utilities/dimension_validator';
import {ReorderDesign} from '../../design_actions/reorder_design';
import {ArchiveDesign} from '../../design_actions/archive_design';
import React, {useContext, useState} from 'react';
import update from 'immutability-helper';
import {If, IfElse} from 'frontier-utilities';
import {
    LAMINATE_THERMAL_GLOSS_FINISH,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    SIZE_STATUS_INSTOCK,
    SHAPE_CARTON_CUSTOM,
    SHAPE_CUSTOM
} from 'frontier-constants';

// styles
import './action_column.scss';

const ColumnContainer = () => {
    const ctx = useContext(AccountDesignsOrdersContext);

    const [byPassError, setByPassError] = useState(false);

    const dmv = new DimensionValidator({
        productTypeId: ctx.order.product_type_id,
        shapeId: ctx.order.shape_id,
        length: ctx.order.length,
        width: ctx.order.width,
        depth: ctx.order.depth
    });

    const {isComplete: isReorderPossible, errors: orderValidationErrors} = validateOrderWithErrors(
        ctx.order
    );

    const canDuplicateOrder =
        !ctx.order.is_printed_proof_only &&
        ctx.order.product_type_id !== PRODUCT_TYPE_GRAPHIC_DESIGN &&
        ctx.order.laminate_id !== LAMINATE_THERMAL_GLOSS_FINISH &&
        (dmv.isValidSize() ||
            parseInt(ctx.order.shape_id) === SHAPE_CUSTOM ||
            parseInt(ctx.order.shape_id) === SHAPE_CARTON_CUSTOM ||
            ctx.order.size.status_id === SIZE_STATUS_INSTOCK);

    const viewInvoicePath = `/account/orders/preview-current-invoice/${ctx.order.cart_id}`;

    return (
        <div className="action-column-12lk">
            <div className="artwork-column-27ux__table-cell">
                <div>
                    <a
                        className="d-flex align-items-center justify-content-start color-accent-primary gap-2"
                        rel="noopener noreferrer"
                        href={viewInvoicePath}
                        target="_blank">
                        <i className={'fa fa-eye'} />
                        <u>Invoice</u>
                    </a>
                </div>

                <If condition={canDuplicateOrder}>
                    <div>
                        <ReorderDesign
                            shouldShowReorderWhenArchived={false}
                            shouldByPassErrors={setByPassError}
                        />
                    </div>
                </If>

                <If condition={!isReorderPossible}>
                    <div className="d-flex align-items-center">
                        <div className="text-info">Reordering is Not Available</div>
                    </div>
                    <div>
                        <ul>
                            {orderValidationErrors.map((e, index) => {
                                if (e.message.toLowerCase().includes('round to nearest 1/')) {
                                    return (
                                        <React.Fragment key={index}>
                                            <IfElse condition={!byPassError}>
                                                <>
                                                    <li key={index}>{e.message}</li>
                                                    <button
                                                        className="color-alert-negative"
                                                        onClick={() => setByPassError(true)}>
                                                        <u>Bypass size error</u>
                                                    </button>
                                                </>
                                                <li className="alert alert-info my-1 p-2">
                                                    You have chosen to bypass a size error
                                                </li>
                                            </IfElse>
                                        </React.Fragment>
                                    );
                                }
                                return <li key={index}>{e.message}</li>;
                            })}
                        </ul>
                    </div>
                </If>
                <If condition={ctx.order.product_type_id !== PRODUCT_TYPE_GRAPHIC_DESIGN}>
                    <div>
                        <ArchiveDesign />
                    </div>
                </If>
            </div>
        </div>
    );
};

export const ActionColumn = props => {
    const {designOrder} = props;
    const order = designOrder.order;

    const [design, setDesign] = useState(designOrder.design);

    const handleToggleIsArchived = value => {
        const updateTarget = {
            is_archived: {$set: value}
        };
        setDesign(update(design, updateTarget));
    };

    const contextValue = {
        designs_order: designOrder,
        handleToggleIsArchived,
        size: order.size,
        design,
        order
    };

    return (
        <AccountDesignsOrdersContext.Provider value={contextValue}>
            <ColumnContainer />
        </AccountDesignsOrdersContext.Provider>
    );
};
